import { render, staticRenderFns } from "./EmployeeDeactivate.vue?vue&type=template&id=4226fe95&"
import script from "./EmployeeDeactivate.vue?vue&type=script&lang=js&"
export * from "./EmployeeDeactivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports